module.exports = __webpack_public_path__ + "static/media/PlaceholderToken.d52ce304.png";